<template>
    <div class="header_container">
        <div :class="isShowMenu ? '' : 'small'" class="left logo"></div>
        <div class="menu-btn left">
            <i :class="isShowMenu ? '' : 'icon-caidan-dakai'" @click="hideMenu()"
               class="iconfont icon-caidan-shousuo"></i>
        </div>
        <el-dropdown @command="handleCommand" class="right" trigger="click">
            <span class="el-dropdown-link">
                <i class="menuFont icon-mine" style="margin-right: 5px;"></i>
                <span>{{UserName}}</span>
                <span class="agent" v-if="typeof AgentUser != 'object' && AgentUser !== ''">{{$t("message.Proxy")}}</span>
                <span>{{AgentUser}}</span>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :class="item.ChineseName === AgentUser ? 'now_item' : ''"
                                  :command="'A+' + item.SAPCode" :key="index"
                                  v-for="(item, index) in AgentList">
                    {{item.ChineseName}}
                </el-dropdown-item>
                <el-dropdown-item command="toSelf" divided v-show="AgentList.length > 0 && typeof AgentUser != 'object' && AgentUser !== ''">{{UserName}}</el-dropdown-item>
                <el-dropdown-item command="logOut" divided>{{$t("message.LoginOut")}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-dropdown @command="handleCommand" class="right" trigger="click" v-if="CompanyList.length > 0">
            <span class="el-dropdown-link">
                <span>{{CompanyName}}</span>
                <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :class="item.CompanySAPCode === CompanyCode ? 'now_item' : ''"
                                  :command="'C+' + item.CompanySAPCode"
                                  :key="index"
                                  v-for="(item, index) in CompanyList">
                    {{curLanguage === 'zh-CN' ? item.CompanyName : item.CompanyShortName}}
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown> -->
        <el-select
            v-if="CompanyList.length > 0"
            @change="handleCompanyCode"
            class="checkLanguage right"
            placeholder=" "
            v-model="CompanyCode">
            <el-option
                :key="index"
                :label="curLanguage === 'zh-CN' ? item.CompanyName : item.CompanyShortName"
                :value="item.CompanySAPCode"
                v-for="(item, index) in CompanyList">
            </el-option>
        </el-select>
        <el-select
                @change="changeLanguage"
                class="checkLanguage right"
                placeholder=" "
                v-model="curLanguage">
            <el-option
                    :key="index"
                    :label="item.Text"
                    :value="item.Value"
                    v-for="(item, index) in languageOptions">
            </el-option>
        </el-select>
        <el-tooltip :content="$t('message.Lang_UserManual')" class="item" effect="dark" placement="bottom">
            <span @click="getHelpDoc()" class="help_icon right">
                <i class="iconfont icon-bangzhu-kong"></i>
            </span>
        </el-tooltip>
    </div>
</template>

<script>
    import {setLocal, getLocal, removeLocal} from "@/config/mUtils";
    import {GetUserDefaultCompany, GetAgentList, GetUserManual} from "../api/apiCommon";

    export default {
        name: '',
        components: {},
        props: {},
        data() {
            return {
                UserName: getLocal('UserName'),
                AgentUser: getLocal('BossAgentUserName'),
                CompanyName: '',
                CompanyCode:'',
                isShowMenu: true,
                curLanguage: getLocal('language') ? getLocal('language') : 'zh-CN',
                languageOptions: [
                    {
                        Value: "zh-CN",
                        Text: '中文'
                    },
                    {
                        Value: "en-US",
                        Text: 'English'
                    }
                ],
                CompanyList: [],
                AgentList: [],
                screenWidth: window.innerWidth
            };
        },
        computed: {},
        watch: {},
        created() {
            this.getUserDefaultCompany();
            this.getAgentList();
        },
        mounted() {
            window.addEventListener('resize', this.handlerSize);
        },
        destroyed() {
        },
        methods: {
            // 语言切换
            changeLanguage() {
                setLocal('language', this.curLanguage);
                this.CompanyList.forEach(ele => {
                    // if (this.curLanguage === 'zh-CN') {
                    //     if (ele.CompanySAPCode === getLocal('CompanyCode')) {
                    //         this.CompanyName = ele.CompanyName;
                    //     }
                    // } else {
                    //     if (ele.CompanySAPCode === getLocal('CompanyCode')) {
                    //         this.CompanyName = ele.CompanyShortName;
                    //     }
                    // }
                });
                this.getLanguageResourceForPage();
            },
            async handleCompanyCode(val) {
                this.$store.dispatch('showLoadingBar');
                setLocal('CompanyCode', val);
                // this.CompanyList.forEach(ele => {
                //     if (this.curLanguage === 'zh-CN') {
                //         if (ele.CompanySAPCode === val) {
                //             this.CompanyName = ele.CompanyName;
                //         }
                //     } else {
                //         if (ele.CompanySAPCode === val) {
                //             this.CompanyName = ele.CompanyShortName;
                //         }
                //     }
                // });
                this.$router.go(0);
            },
            // 头部下拉
            async handleCommand(command) {
                if (command === "logOut") {
                    this.$message.success(this.$t("message.LogOutSuccessful"));
                    this.$router.push("/");
                    sessionStorage.clear();
                } else if (command == 'toSelf') {
                    this.$store.dispatch('showLoadingBar');
                    this.AgentUser = '';
                    removeLocal('BossAgentUserCode');
                    removeLocal('BossAgentUserName');
                    this.$router.go(0);
                } else if (command.split('+')[0] === 'C') {
                    this.$store.dispatch('showLoadingBar');
                    setLocal('CompanyCode', command.split('+')[1]);
                    // this.CompanyList.forEach(ele => {
                    //     if (this.curLanguage === 'zh-CN') {
                    //         if (ele.CompanySAPCode === command.split('+')[1]) {
                    //             this.CompanyName = ele.CompanyName;
                    //         }
                    //     } else {
                    //         if (ele.CompanySAPCode === command.split('+')[1]) {
                    //             this.CompanyName = ele.CompanyShortName;
                    //         }
                    //     }
                    // });
                    this.$router.go(0);
                } else if (command.split('+')[0] === 'A') {
                    this.$store.dispatch('showLoadingBar');
                    setLocal('BossAgentUserCode', command.split('+')[1]);
                    this.AgentList.forEach(ele => {
                        if (ele.SAPCode === command.split('+')[1]) {
                            this.AgentUser = ele.ChineseName;
                            setLocal('BossAgentUserName', ele.ChineseName);
                        }
                    });
                    this.$router.go(0);
                }
            },
            // 隐藏导航
            hideMenu() {
                this.isShowMenu = !this.isShowMenu;
                if (this.isShowMenu) {
                    this.$store.dispatch('showMenuBar');
                } else {
                    this.$store.dispatch('hideMenuBar');
                }
            },
            // 初始化导航
            setLayout(width) {
                if (width > 1200) {
                    this.isShowMenu = true;
                    this.$store.dispatch('showMenuBar');
                } else {
                    this.isShowMenu = false;
                    this.$store.dispatch('hideMenuBar');
                }
            },
            // 窗口变化
            handlerSize() {
                this.screenWidth = window.innerWidth;
                this.setLayout(this.screenWidth);
            },
            // 获取头部公司数据
            async getUserDefaultCompany() {
                this.CompanyList = [];
                try {
                    let data = await GetUserDefaultCompany(
                        getLocal('ADAccount'),
                        getLocal('BossAgentUserCode'),
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.CompanyList = data.data.companyInfo
                        console.log(this.CompanyList)
                        //判断当前数据源是否有缓存之前的CompanyCode，如果没有，取默认第一条 
                        if(this.CompanyList.length>0){
                            let array = this.CompanyList.filter(x=>x.CompanySAPCode==getLocal('CompanyCode'))
                            this.CompanyCode=array.length>0?getLocal('CompanyCode'):this.CompanyList[0].CompanySAPCode
                        }
                        
                        // data.data.companyInfo.forEach(ele => {
                        //     if (this.curLanguage === 'zh-CN') {
                        //         if (ele.CompanySAPCode === getLocal('CompanyCode')) {
                        //             this.CompanyName = ele.CompanyName;
                        //         }
                        //     } else {
                        //         if (ele.CompanySAPCode === getLocal('CompanyCode')) {
                        //             this.CompanyName = ele.CompanyShortName;
                        //         }
                        //     }
                        //     this.CompanyList.push(ele);
                        // })
                        
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            // 被代理人（老板）列表
            async getAgentList() {
                this.AgentList = [];
                try {
                    let data = await GetAgentList(
                        getLocal('UserCode'),
                        getLocal('CompanyCode')
                    );
                    if (data.error_code === '0') {
                        if (data.data.length > 0) {
                            this.AgentList = data.data;
                        } else {
                            setLocal('BossAgentUserCode', '');
                            setLocal('BossAgentUserName', '');
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            //获取帮助手册
            async getHelpDoc() {
                try {
                    let data = await GetUserManual();
                    if (data.error_code === '0') {
                        window.open(data.data, "_blank");
                    }
                } catch (error) {
                    console.log(error);
                }
            },
        }
    };
</script>
